import { CircularProgress, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import ChevronIcon from "assets/icons/ChevronIcon";
import CrossIcon from "assets/icons/CrossIcon";
import Resize from "assets/icons/Resize";
import HashtagIcon from "assets/icons/Hashtag";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import ListSubItem from "components/Table2/CellComps/ListSubItem";
import { MouseEvent, useEffect, useMemo, useRef, useState } from "react";
import { Virtuoso } from "react-virtuoso";
import { useSelector } from "react-redux";
import Icon from "components/Shared/atoms/Icon";
import axios from "../../axios/axios";
export default function BasicSelect(props: BasicSelectProps) {
  /* ---------------------------------- Redux --------------------------------- */
  const store = useSelector((state: any) => state);
  const appSettings = store.appReducer?.appSettings || [];
  /* ---------------------------------- Props --------------------------------- */
  const { onChange, defaultValue, label, style, required, onClear, labelKey, valKey, checkSettings } = props;
  const { btnStyle, menuItemStyle, disabled, actionSection, } = props;
  const { preferences, withSearch, withClear, footer, withRefresh, refreshList } = props;
  const { requestInfo, beforeLoadingPerSelectBox, searchColumns, name } = props
  // const [searchText, setSearchText] = useState("")
  /* ---------------------------------- Hooks --------------------------------- */
  const btnRef = useRef<any>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [value, setValue] = useState<string | number | null | undefined>("");
  // const [options, setOptions] = useState(props.options);
  const [curOption, setCurOption] = useState(props.options ? props.options[0] : undefined);
  const [isNested, setNested] = useState(props.isNested);
  const [placeholder, setPlaceholder] = useState<string | number>();
  const [newData, setNewData] = useState<any>(props.options)
  const [curIndex, setCurrIndex] = useState(-1);
  const [page, setPage] = useState(1)
  const ref = useRef<any>(null);
  const increaseViewportBy = requestInfo ? { top: 0, bottom: 0 } : { top: 300, bottom: 300 }

  // /* -------------------------------- Variables ------------------------------- */
  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;
  const flatOptions = rec(props.options, "childs", []);
  const size = preferences?.size || 3;
  const fontSizes = { 1: 10, 2: 12, 3: 14, 4: 16, 5: 18 };
  const heights = { 1: 28, 2: 40, 3: 52, 4: 64, 5: 76 };
  const elHeights = { search: 48, refresh: 40, footer: 56 };
  const menuHeight = withRefresh && !isNested ? 450 : 400;
  let listHeight = menuHeight;
  if (withSearch) listHeight -= elHeights.search;
  if (withRefresh) listHeight -= elHeights.refresh;
  if (footer) listHeight -= elHeights.footer;
  /* --------------------------------- Effects -------------------------------- */
  useEffect(() => {
    if (requestInfo?.url && defaultValue && !open && defaultValue != value) {
      getData(defaultValue, true, false, false)
      return
    }
    setValue(defaultValue)
  }, [defaultValue]);//
  useEffect(() => {
    if (!requestInfo?.url)
      setNewData(props.options)

  }
    , [props.options]);
  useEffect(() => setNested(props.isNested), [props.isNested]);

  useEffect(() => {
    if (props.options && Array.isArray(props.options)) {
      let defaultOption = props.options?.find((o: any) => o.default);
      if (!defaultValue && defaultOption && !value && !props.noDefOption) {
        setValue(defaultOption.id);
        onChange && onChange(defaultOption.id, defaultOption);
      }
    }
    if (checkSettings && appSettings[checkSettings.settingName]) {
      setValue(appSettings[checkSettings.settingValue]);
      const option = getOption(appSettings[checkSettings.settingValue], props.options)?.option;
      onChange && onChange(option?.id, option);
    }
  }, []);

  useEffect(() => {
    if (value === undefined) {
      setPlaceholder(undefined);
    }
    const opts = !isNested ? newData : flatOptions;
    const o = getOption(value, opts);
    const option: any = o && o.option;
    let key = labelKey || (isNested ? "title" : "label");
    if (option) {
      setCurOption(option);
      option[key] && setPlaceholder(option[key]);
    } else {
      setPlaceholder("")
    }

    const i = o && o.index;
    if (i !== undefined) {
      setCurrIndex(i);
      setTimeout(() => {
        ref.current?.scrollIntoView({
          index: i,
          behavior: "auto"
        });
      }, 110);
    }
  }, [value]);

  const getReqParams = () => {
    let params: IDefaultParams = { page, limit: 100 }
    if (requestInfo && withRefresh && beforeLoadingPerSelectBox) {
      const { method, url } = requestInfo
      params = beforeLoadingPerSelectBox({ name: props.name || url, status: "beforeSendRequest", params })
    }
    return { params }
  }

  const [loading, setLoading] = useState<boolean>(false)
  const [textSearch, setTextSearch] = useState<string>("")
  const [latestData, setLatestData] = useState(false)

  const getData = async (textSearch?: string | number, setDefaultValue?: boolean, byScroll?: boolean, fromSearch?: boolean) => {
    const token = store.businessReducer.business?.token;
    const text = textSearch
    if (loading) return
    if (byScroll && latestData && !textSearch) return
    if (requestInfo && withRefresh) {
      const { method, url } = requestInfo
      if (method === "post") {
        const { params } = getReqParams()
        setLoading(true)
        axios.post(url, params, {
          headers: { Authorization: `Bearer ${token}` }
        }).then((res: any) => {
          setLoading(false)

        })
      } else {
        let { params } = getReqParams()

        if (text !== "") {
          setLatestData(false)
          params["primarySearch"] = text
          params["searchColumns"] = setDefaultValue ? "id" : searchColumns
        }
        setLoading(true)

        axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
          params
        }).then((res: any) => {
          if (beforeLoadingPerSelectBox) {
            const data = beforeLoadingPerSelectBox({ name: props.name || url, status: "afterSendRequest", params: res.data })
            setLoading(false)
            if (data.length === 0 || data.length < 100) {
              setPage(1)
              if (byScroll) setLatestData(true)

            }
            if (textSearch && textSearch !== "") {
              if (setDefaultValue) {
                setNewData((state: any) => {

                  handleChange(data[0])
                  if (byScroll) {
                    setPage(state => state + 1)

                  } else
                    setPage(1)
                  return [...state, ...data]
                })


              }
              setNewData(data)
              setPage(1)
              return
            }
            if (byScroll) {
              setNewData((state: any) => [...state, ...data])
              setPage(state => state + 1)
              return
            }
            setNewData(data)


          }

        }).finally(() => {
          setLoading(false)
        })
      }
    }
  }
  const loadMore = async (index: number) => {
    if (textSearch && textSearch !== "") return
    getData('', false, true)
  }
  const debounce = (fn: Function, ms = 1000) => {
    let timeoutId: ReturnType<typeof setTimeout>;
    return function (this: any, ...args: any[]) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn.apply(this, args), ms);
    };
  };
  useEffect(() => {
    if (!requestInfo?.url)
      setNewData(props.options)

    return () => {

    }
  }, [props.options])
  const tempGetData = useMemo(() => debounce(getData,1000), [beforeLoadingPerSelectBox])
  useEffect(() => {
    if (open && withRefresh && requestInfo?.url) {
      getData("", false, true, true)


    } else if (!requestInfo?.url && refreshList && open) {
      refreshList()
    } else if (!open) {
      setPage(1)
      setNewData(props.options)
      setLoading(false)
      setNested(props.isNested)
    }
  }, [anchorEl]);
  useEffect(() => {
    if (open) {
      setTimeout(() => {
        ref.current?.scrollIntoView({
          index: curIndex,
          behavior: "auto"
        });
      }, 110);
    }
  }, [anchorEl]);
  // useEffect(() => {
  //   if (defaultValue && options && forceCallChanged) {
  //     const opts = !isNested ? options : flatOptions;
  //     const o = getOption(value, opts);
  //     const option: any = o && o.option;
  //     if (option && onChange) {
  //       onChange(value, option)
  //     }

  //   }

  //   return () => {

  //   }
  // }, [defaultValue, options?.length])

  /* -------------------------------- Functions ------------------------------- */
  const handleChange = (option: any) => {
    const val = option.value || option.id;
    setPage(1)
    handleClose();
    // setSearchText("")
    !isNested && setValue(val);
    let key = labelKey || (isNested ? "title" : "label");
    option && option[key] && setPlaceholder(option[key]);
    onChange && onChange(val, option);
    setNested(props.isNested);
  };

  function handleClose() {
    setAnchorEl(null);
    setPage(1)
    setLatestData(false)
    // setSearchText("")
    setLoading(false)
    document.getElementById("main-sidebar")?.classList.remove("mui-opened-menu");
    document.getElementById("main-header")?.classList.remove("mui-opened-menu");
  }

  function getOption(v: BasicSelectProps["defaultValue"], o: BasicSelectProps["options"]) {
    let id = 0;
    if (v && typeof v === "string") id = parseInt(v);
    if (v && typeof v === "number") id = v;
    const key = valKey || "value";
    if (!o || !Array.isArray(o)) return undefined;
    const i = o.findIndex((x: any) => x[key] && (x[key] === id || x[key] === v));
    return { option: o[i], index: i };
  }

  function search(text: string) {
    if (requestInfo?.url) {
      if (text.length > 2||text.length===0) {
        return tempGetData(text, false, false, true)
      }
    }
    let data = props.isNested ? flatOptions : props.options;
    if (!text || text === "") return data;
    const texts = text.split(" ");
    return data.filter((x: any) => {
      let flag = true;
      const sources = [x.label, x.dsc, x.searchKeys, x.code];
      texts.map((t) => {
        if (
          !sources
            .filter((x) => x)
            .join(" ")
            .toLowerCase()
            .includes(t.toLowerCase())
        ) {
          flag = false;
        }
      });
      return flag;
    });

  }

  function rec(data: any, key: string, arr: any[]) {
    if (data && data[key] && data[key].length === 0)
      arr.push({
        title: data.title,
        id: data.id,
        label: data.label || data.title,
        value: data.value || data.id,
        code: data?.code || ""
      });
    if (data && data[key] && data[key].length > 0) {
      for (const item of data[key]) {
        rec(item, key, arr);
      }
    }
    return arr;
  }

  function handleKeyDown(e: React.KeyboardEvent<HTMLDivElement>) {
    let i = curIndex;
    if (e.code === "ArrowUp" && i > 0) {
      i--;
    } else if (e.code === "ArrowDown" && i < newData?.length - 1) {
      i++;
    } else if (["Enter", "NumpadEnter"].includes(e.code)) {
      e.preventDefault();
      handleChange(newData[i]);
    }
    if (i !== curIndex) {
      setCurrIndex(i);
      ref.current?.scrollIntoView({
        index: i,
        behavior: "smooth"
      });
    }
  }

  /* ----------------------------------- JSX ---------------------------------- */
  const Item = ({ index, option }: { option: any; index: number }) => {
    const { image, icon, label, dsc, ind, title, footer, render, code } = option;

    const fontSize = fontSizes[size];
    return (
      <Tooltip title={title}>


        <MenuItem
          key={index}
          onClick={() => handleChange(option)}
          style={{ ...menuItemStyle }}
          className={`py-3 w-full ${index === curIndex ? "bg-slate-100" : ""}`}
        >
          {render ? (
            render(option)
          ) : (
            <div className="flex items-center w-full gap-4">
              {image && (
                <div
                  className={`rounded-full overflow-hidden border border-slate-200 bg-center bg-cover bg-no-repeat`}
                  style={{
                    backgroundImage: `url("${image}")`,
                    minHeight: 24,
                    minWidth: 24
                  }}
                />
              )}
              {icon && (
                <div
                  className={`rounded-full overflow-hidden border p-1 border-slate-200 bg-blue-5 flex justify-center items-center`}
                  style={{
                    minHeight: heights[size],
                    maxHeight: heights[size],
                    minWidth: heights[size],
                    maxWidth: heights[size]
                  }}
                >
                  <img src={icon} alt="" className="w-full pointer-events-none" />
                </div>
              )}
              <div className="flex flex-col justify-center w-full gap-1 overflow-hidden">
                {ind && title ? (
                  <div className="flex items-center gap-1 text-xs md:text-sm">
                    <span style={{ fontSize: fontSize + 2 }} className="text-dark-6">
                      {ind}
                    </span>
                    <div className="flex items-center gap-1">
                      <span
                        className="flex items-center justify-center w-4 h-4 rounded bg-slate-100"
                        style={{ fontSize }}
                      >
                        <HashtagIcon color="#7E8C9E" style={{ transform: "scale(0.8)" }} />
                      </span>
                      <span>{" - "}</span>
                    </div>
                    <span style={{ fontSize }} className="overflow-hidden text-ellipsis text-dark-6">
                      {title}
                    </span>
                  </div>
                ) : (
                  <span style={{ fontSize }} className="overflow-hidden text-ellipsis">
                    {code && `${code} - `} {label}
                  </span>
                )}
                <span className="text-sm text-slate-400">{dsc}</span>
                {footer}
              </div>
            </div>
          )}
        </MenuItem>
      </Tooltip>
    );
  };

  const Button1 = () => {
    return (
      <div className="flex items-end gap-6" style={{ ...props.containerStyle }}>
        <div className="w-full" style={{ ...(style || {}) }}>
          {label && (
            <div className="text-sm font-normal h-8 pr-2 pb-3 text-[#33383D]">
              <span>
                {label}
                {required && " *"}
              </span>
            </div>
          )}
          <div className="flex items-center gap-2">
            <div
              className="flex items-center justify-between w-full gap-3 px-2 text-sm rounded-md cursor-pointer"
              aria-describedby={id}
              ref={btnRef}
              style={{
                minHeight: 40,
                minWidth: 150,
                border: "1px solid #C2D0E3",
                ...btnStyle
              }}
              onClick={(e) => {
                if (!disabled) {
                  setAnchorEl(e.currentTarget);
                  document.getElementById("main-sidebar")?.classList.add("no-transition", "mui-opened-menu");
                  document.getElementById("main-header")?.classList.add("mui-opened-menu");
                }
              }}
            >
              <div className="flex justify-start w-full overflow-hidden">
                <span
                  className="whitespace-nowrap "
                  style={{
                    color: placeholder ? "#3D3D3D" : "#747575",
                    fontSize: fontSizes[size],
                    lineHeight: 1.2,
                    ...props.btnTextStyle
                  }}
                >
                  {placeholder || props.placeholder}
                </span>
              </div>
              <span className="flex items-center">
                {withClear && Boolean(value) && (
                  <IconButton
                    style={{ width: 24, height: 24 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setValue(undefined);
                      setPlaceholder(undefined);
                      onClear && onClear();
                    }}
                  >
                    <CrossIcon bgColor="transparent" color="#7E8C9E" scale={2} />
                  </IconButton>
                )}
                <ChevronIcon rotate={open ? "top" : undefined} color="#7E8C9E" />
              </span>
            </div>
            {actionSection}
          </div>
        </div>
        {props.sideSection !== 0 && props.sideSection}
      </div>
    )
  };

  const Button2 = () => {
    const img = !curOption?.hideImageOnBtn && (curOption?.image || curOption?.icon);
    const value = curOption?.label || props.placeholder || "";
    const label = props.label;
    return (
      <div
        ref={btnRef}
        className="flex items-center gap-4 cursor-pointer"
        onClick={(e) => {
          if (!disabled) {
            setAnchorEl(e.currentTarget);
            document.getElementById("main-sidebar")?.classList.add("no-transition", "mui-opened-menu");
            document.getElementById("main-header")?.classList.add("mui-opened-menu");
          }
        }}
      >
        {img && <Icon url={img} />}
        <div className="flex flex-col gap-2">
          {label && <div className="text-xs text-dark-3">{label}</div>}
          <div className="flex items-center gap-2">
            {value && (
              <div className="pb-1 text-sm font-bold border-blue-1" style={{ borderBottom: "2px dashed" }}>
                {value}
              </div>
            )}
            <div className="flex items-center justify-center w-5 h-5 bg-gray-200 rounded-full cursor-pointer">
              <ChevronIcon color="#95A3B5" />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const buttons = { 1: Button1, 2: Button2 };

  const ButtonComp = buttons[props.preferences?.button || 1];
  ///ojaghiAdded

  const [resize, setResize] = useState({ x: 400 });
  const handleMouseDown = (event: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => {
    //  setIsResizing(true);
    const initialWidth = resize.x;
    const initialX = event.clientX;

    const handleMouseMove = (event: globalThis.MouseEvent) => {
      //  if (isResizing) {
      const newWidth = initialWidth - (event.clientX - initialX);
      setResize({ x: newWidth });
      // }
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove)
      document.removeEventListener("mouseup", handleMouseUp)
      //setIsResizing(false);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp, { once: true });
  };
  const OnLoadData = () => {
    if (requestInfo?.url)
      return (
        <div
          style={{
            padding: '2rem',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <CircularProgress color="primary" size={40} />
        </div>
      )
    return <></>
  }
  ///ojaghiAdded



  return (
    <>
      {ButtonComp()}
      <Menu
        id="basic-menu"
        sx={{ direction: "rtl" }}
        tabIndex={0}
        PaperProps={{
          style: {
            width: resize.x,//btnRef.current && btnRef.current.offsetWidth,
            maxHeight: menuHeight,
            overflow: isNested ? "auto" : "hidden",
            minWidth: props.isNested ? 400 : "auto",
            ...props.menuStyle
          }
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
          style: { padding: 0 }
        }}
        onKeyDown={handleKeyDown}
      >
        {withSearch && (
          <div
            className="sticky top-0 z-10 p-1 bg-white border-slate-200"
            style={{ borderBottom: "1px solid", height: elHeights.search }}
          >
            <BasicTextInput

              TextFieldProps={{ autoFocus: true, inputProps: { style: { fontSize: fontSizes[size] } } }}
              placeHolder="جستجو"
              onChange={(val) => {
                let v = val.toString();
                setTextSearch(v)
                if (requestInfo?.url) {
                  return search(v)

                }
                if (val === "") {
                  setNested(props.isNested);
                  setNewData(props.options);
                } else {
                  props.isNested && setNested(false);

                  setNewData(search(v));
                }
              }}
              style={{ border: 0, height: heights[size], fontSize: fontSizes[size] }}
            />
          </div>
        )}
        {/* {
        withRefresh && (
          <div
            className="flex flex-row items-center justify-between w-full px-4 py-3"
            style={{ height: elHeights.refresh }}
          >
            <div
              onClick={() => !isLoading && refreshList()}
              className="flex flex-row items-center cursor-pointer whitespace-nowrap "
            >
              <div className={`${isLoading ? "animate-spin" : ""}`}>
                <RefreshIcon scale={0.8} />
              </div>
              <span className="mr-2 text-xs font-medium font-IRANSans text-blue-1">بروزرسانی لیست</span>
            </div>
            
          </div>
        )
        } */}

        <div className="h-full">
          {isNested ? (
            <ListSubItem

              data={newData}
              onChange={(item) => handleChange(item)}
              sizes={{ font: fontSizes[size] }}
            />
          ) : (

            Array.isArray(newData) &&
              !props.noVirtual ?
              <Virtuoso
                endReached={loadMore}
                components={{ Footer: OnLoadData }}
                ref={ref}
                style={{ height: listHeight, overflowX: "hidden" }}
                totalCount={newData?.length}
                increaseViewportBy={increaseViewportBy}
                data={newData}
                itemContent={(index, option) => <Item {...{ index, option }} />}
              />
              : (
                <div className="overflow-y-auto" style={{ maxHeight: listHeight }}>
                  {newData && Array.isArray(newData) && newData?.map((option: any, index: number) => (
                    <Item key={index} {...{ option, index }} />
                  ))}
                </div>
              ))}
        </div>
        {footer && (
          <div
            className="sticky bottom-0 p-2 bg-white border-slate-200"
            style={{ borderTop: "1px solid", height: 26 }}
          >
            <div
              onClick={() => {
                if (props.closeOnFooterClick) setAnchorEl(null);
              }}
            >
              {footer}
            </div>
          </div>
        )}
        <div
          className="sticky z-50 bottom-0 flex flex-row-reverse"

        >
          <div className="bg-transparent cursor-grab rotate-90 ['&>svg']:fill-blue-1 " onMouseDown={handleMouseDown}><Resize /></div>

        </div>
      </Menu>
    </>
  );
}
